export const REQUEST_ROOT = '/loans/request';

const policies: Record<string, {entry: string; allowed: string[]}> = {
    calculator: {
        entry: '',
        allowed: [
            '',
            'confirmLoanTemplate',
            'createNewRequest',
            'TemporaryRegistered',
            'additionalInfo',
            'basickInfo',
        ],
    },
    TemporaryRegistered: {
        entry: 'additionalInfo',
        allowed: ['additionalInfo', 'basickInfo'],
    },
    WaitForInquiryPayment: {
        entry: 'fee',
        allowed: ['fee', 'otp', 'inquiryResult'],
    },
    WaitForInquiry: {entry: 'inquiryResult', allowed: ['otp', 'inquiryResult']},
    InquiryRejected: {
        entry: 'inquiryResult',
        allowed: ['otp', 'inquiryResult'],
    },
    WaitForCustomerDocument: {entry: '', allowed: ['']},
    WaitForRequestApprove: {
        entry: 'requestApproval',
        allowed: ['requestApproval'],
    },
    WaitForSalaryDeduction: {
        entry: 'salaryDeduction',
        allowed: ['salaryDeduction'],
    },
    WaitForDocumentReceiveApprove: {
        entry: 'documentApproval',
        allowed: ['documentApproval'],
    },
    WaitForPrepayment: {entry: 'prepayment', allowed: ['prepayment']},
    WaitForCustomerContractSign: {
        entry: 'viewContract',
        allowed: ['viewContract', 'signContract'],
    },
    WaitForSendToBank: {entry: 'sendToBank', allowed: ['sendToBank']},
    WaitForBankApprove: {entry: 'accepted', allowed: ['accepted']},
    Assigned: {entry: 'accepted', allowed: ['accepted']},
    CanceledByCustomer: {entry: 'rejected', allowed: ['rejected']},
    CanceledBySetad: {entry: 'rejected', allowed: ['rejected']},
};

const documentRoutes = [
    'Identity',
    'Residential',
    'Incomes',
    'AdditionalFields',
    'Cheque',
    'Cheque/chequeRegister',
    'KycVideo',
    'KycVideo/captureVideo',
    'Guarantors',
    'Guarantors/guarantorCompletion',
    'Guarantors/guarantorInfo',
    'Guarantors/guarantorRegister',
    'Guarantors/otp',
    'Guarantors/guarantorInquiryResult',
];

// null means an unsupported server status: fail closed instead of showing a form.
export function resolveLoanRoute(
    status: string,
    pathname: string,
    availableForms: string[] = [],
    creation?: {templateSelected: boolean; calculationReady: boolean}
) {
    if (!Object.prototype.hasOwnProperty.call(policies, status)) return null;
    const policy = policies[status];
    const path = pathname.replace(/\/+$/, '');
    const relative =
        path === REQUEST_ROOT
            ? ''
            : path.startsWith(`${REQUEST_ROOT}/`)
              ? path.slice(REQUEST_ROOT.length + 1)
              : undefined;
    if (status === 'calculator' && relative) {
        if (!creation?.templateSelected) return REQUEST_ROOT;
        if (
            ['TemporaryRegistered', 'additionalInfo', 'basickInfo'].includes(
                relative
            ) &&
            !creation.calculationReady
        ) {
            return `${REQUEST_ROOT}/createNewRequest`;
        }
    }
    const allowedDocument =
        status === 'WaitForCustomerDocument' &&
        relative !== undefined &&
        documentRoutes.includes(relative) &&
        availableForms.includes(relative.split('/')[0]);
    if (
        relative !== undefined &&
        (policy.allowed.includes(relative) || allowedDocument)
    )
        return path;
    return policy.entry ? `${REQUEST_ROOT}/${policy.entry}` : REQUEST_ROOT;
}
